import { render, staticRenderFns } from "./crudSettings.vue?vue&type=template&id=3ed42ca1&"
import script from "./crudSettings.vue?vue&type=script&lang=js&"
export * from "./crudSettings.vue?vue&type=script&lang=js&"
import style0 from "./crudSettings.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports